import { ArrowRight, ArrowUpRight, Check } from "lucide-react";
import { Link } from "react-router-dom";
import { INSTAGRAM } from "@/lib/circle";
import { track } from "@/lib/site";

export default function Success({ already }) {
    return (
        <div className="py-4 ic-step" data-testid={already ? "ic-already" : "ic-success"}>
            <span className="ic-check inline-flex h-16 w-16 items-center justify-center rounded-full bg-forest text-cream mb-8">
                <Check className="h-7 w-7" strokeWidth={1.75} />
            </span>
            <h2 className="font-serif text-3xl md:text-[2.4rem] leading-[1.05] text-forest tracking-tight" tabIndex={-1} data-ic-heading>
                {already ? "You're already in the Circle." : "Welcome to the Investor Circle."}
            </h2>
            <p className="mt-4 text-ink/80 leading-relaxed">
                {already ? "This email address is already registered. We'll be in touch when there's something relevant to share." : "You're now part of our growing community. We'll be in touch when there's something relevant to share."}
            </p>
            <p className="mt-3 text-muted_text leading-relaxed">In the meantime, follow our journey as we build Verde 2050.</p>
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
                <Link to="/" data-testid="ic-explore" className="group inline-flex items-center justify-center gap-3 rounded-full bg-forest text-cream hover:bg-forest-hover px-7 py-4 text-sm font-medium transition-colors">
                    Explore Verde 2050 <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                </Link>
                <a href={INSTAGRAM} target="_blank" rel="noopener noreferrer" onClick={() => track("instagram_click", "investor_circle_success")} data-testid="ic-follow"
                   className="inline-flex items-center justify-center gap-2 rounded-full border border-forest/40 text-forest hover:bg-forest hover:text-cream px-7 py-4 text-sm font-medium transition-colors">
                    Follow Walk the Land <ArrowUpRight className="h-4 w-4" />
                </a>
            </div>
        </div>
    );
}
